export default function NewsArrow({ width, height, isRotated, color, strokeWidth }) {
  return (
    <svg
      style={{
        transform: isRotated ? 'scaleY(-1)' : 'scaleY(1)',
        transition: 'transform 0.3s ease',
      }}
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.65019 18.3191L18.6207 1.34857M18.6207 1.34857L2.593 1.34857M18.6207 1.34857L18.6207 17.3763"
        stroke={color || '#F6F6F6'}
        strokeWidth={strokeWidth || '2'}
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}
